
/* injects from baggage-loader */

import { CharThumbs } from '_appRoot/index.const';

export const introBallons = [
    'Este é o bosque de ícona, onde até mesmo os elementos inanimados da paisagem têm expressões faciais.',
    'Para derrotar o Albedo nesta fase, você precisará vencê-lo em mais um desafio de enigmas.',
    'Leia a página que foi roubada antes de começar.'
]
export const tutorialBallons = [
    'Duvido que você seja capaz de decifrar a expressão do rosto de liz!'
];

export const abeldoChallenge1Ballons = [
    'Duvido que você seja capaz de decifrar a expressão do rosto de liz!'
];

export const abeldoChallenge2Ballons = [
    'Agora, eu o desafio a decifrar a expressão do rosto do pai de Liz!'
];

export const abeldoChallenge3Ballons = [
    'Quero ver você decifrar essa agora! <br> Você deve ficar atento aos detalhes dos quadrinhos!'
];

export const abeldoChallenge4Ballons = [
    'Duvido você descobrir em qual das duas imagens parece haver maior intensidade na ação!'
];

export const successExercise1 = [
    'Muito bem! <br> Albedo está menos poderoso agora!'
]

export const successExercise2 = [
    '<small>Muito bem!</small> <br><small> As Expressões faciais são um dos elementos não verbais mais importantes das histórias em quadrinhos.</small>',
    'É por meio delas que podemos entender como a personagem está se comunicando ou se sentindo.',
    'Elas podem expressar uma emoção de forma independente, dando vida à narrativa.'
]

export const successExercise3 = [
    'Muito bem! <br> Albedo está menos poderoso agora!'
]

export const successExercise4 = [
    '<small>Muito bem! </small><br> <small>O Primeiro quadro apresenta mais linhas próximas à boca da personagem, indicando um grito mais intenso.</small>',
    'Essas linhas são conhecidas como "linhas cinéticas" e também são elementos não verbais das histórias em quadrinhos.',
    'Elas funcionam como indicadores de movimentos e de intensidade.',
    'No primeiro quadro, o grito do pai de liz parece mais intenso, reforçando a preocupação dele com a distância da filha.'
]

export const failExercise1 = [
    '<small>Parece que a opção marcada não está relacionada à expressão facial de liz. Observe novamente o quadrinho e tente outra vez.</small>'
]

export const failExercise2 = [
    '<small>Parece que a opção marcada não está relacionada à expressão facial do pai de liz. Observe novamente o quadrinho e tente outra vez.</small>'
]

export const failExercise3 = [
    '<small>Parece que esta não é a ação correta. Observe novamente o quadrinho e tente outra vez.</small>'
]

export const failExercise4 = [
    '<small>Parece que a opção marcada não está relacionada à intensidade da ação da personagem. Observe novamente o quadrinho e tente outra vez...</small>'
]

export const scene1 = [
    {
        bg: require('_images/stages/stage-three/croma-abeldo-dialogs/scene-1.png'),
        text: ['Encontrei você, Albedo!'],
        thumb: CharThumbs.croma,
        visible: false
    },
    {
        bg: require('_images/stages/stage-three/croma-abeldo-dialogs/scene-2.png'),
        text: ['Ahhhhhhhh!!!'],
        thumb: CharThumbs.abeldo,
        visible: false
    },
];


export const scene2 = [
    {
        bg: require('_images/stages/stage-three/croma-abeldo-dialogs/scene-3.png'),
        text: ['Consegui recuperar uma das <b>páginas</b>!'],
        thumb: CharThumbs.croma,
        visible: false
    },
    {
        bg: require('_images/stages/stage-three/croma-abeldo-dialogs/scene-4.png'),
        text: ['Oh, não! Albedo <b>escapou</b> para outro esconderijo!<br> Vamos <b>Continuar</b>!'],
        thumb: CharThumbs.croma,
        visible: false
    },
];

export const exercise1 = [
    {
        value: 1,
        text: 'Preocupada'
    },
    {
        value: 2,
        text: 'Empolgada'
    },
    {
        value: 3,
        text: 'Espantada'
    },
    {
        value: 4,
        text: 'Irritada'
    },
];

export const exercise2 = [
    {
        value: 1,
        text: 'Sonolento'
    },
    {
        value: 2,
        text: 'Animado'
    },
    {
        value: 3,
        text: 'Assustado'
    },
    {
        value: 4,
        text: 'Preguiçoso'
    },
];

export const exercise3 = [
    {
        value: 1,
        text: 'Pensando'
    },
    {
        value: 2,
        text: 'Gritando'
    },
    {
        value: 3,
        text: 'Falando'
    },
    {
        value: 4,
        text: 'Sorrindo'
    },
];

export const exercise4 = [
    {
        value: 1,
        image: {
            default: require('_images/stages/stage-three/exercise-4/01.png'),
            active: require('_images/stages/stage-three/exercise-4/01-active.png')
        }
    },
    {
        value: 2,
        image: {
            default: require('_images/stages/stage-three/exercise-4/02.png'),
            active: require('_images/stages/stage-three/exercise-4/02-active.png')
        }
    }
];


// WEBPACK FOOTER //
// ./src/app/pages/stage-three/stage-three.const.js